import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const UsersPage = lazy(() => import('~/features/platform/pages/users-page'));

export const Route = createFileRoute('/_authenticated/_tenant/platform/users')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <UsersPage />
    </Suspense>
  ),
});
